/// <reference path="../../../../core/web/site/embedded/script/core.js" />
if (!rtAPI) var rtAPI = {};

//#region Init

rtAPI.call = {};

//#endregion

//#region Call

rtAPI.call.APIEndPoint = async function (module, command, data) {
    return await this.endPoint('/api', module, command, data);
}

rtAPI.call.endPoint = async function (rootURL, module, command, data) {
    try {
        if (!data) data = {};
        var seleniumInfoPageKey = document.getElementsByTagName("selenium-info-page-key")[0];
        data.seleniumInfoPageKey = '';
        if (seleniumInfoPageKey != undefined) data.seleniumInfoPageKey = seleniumInfoPageKey.innerHTML;
        rtAPI.loadingPanel.show();
        rtAPI.sysError.clear();
        rtAPI.messages.clear();
        const endPointURL = encodeURI(`${rootURL}/${module}/${command}/?${rtAPI.query.string}`);
        const options = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data),
            credentials: 'include',
            mode: 'cors', // no-cors, *cors, same-origin
            cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
            redirect: 'follow', // manual, *follow, error
            referrerPolicy: 'strict-origin-when-cross-origin'// no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        }
        const response = await fetch(endPointURL, options)
        if (!response.ok) return rtAPI.sysError.write(response.status, response.statusText, response.url);

        const header = await response.json();
        rtAPI.lastHeader = header;
        if (header.dgData != undefined) rtAPI.dg.update(header.dgData)
        if (!header.statusOk) {
            rtAPI.sysError.write(header.statusCode, header.errorName, header.errorMessage);
            return header;
        }
        if (header.monitorLoginStatus && header.isLoggedIn === false) {
            window.location.href = window.location.href;
        }
        if (header.redirectUrl != undefined) {
            rtAPI.loadingPanel.show();
            document.location = header.redirectUrl;
            return header;
        }
        if (header.reloadPage) {
            rtAPI.loadingPanel.show();
            document.location.reload();
            return header;
        }
        rtAPI.messages.renderMessages(header.messages);
        header.messages = null;
        rtAPI.loadingPanel.hide();
        //if (header.mustChangePassword) { //Will go it to a loop needs to go elsewhere
        //    if (!rtAPI.security) {
        //        alert("js security api not included on this page");
        //        return header;
        //    }
        //    rtAPI.security.handle.showMustChangePassword();
        //}
        return header;
    }
    catch (errorMessage) {
        rtAPI.loadingPanel.hide();
        rtAPI.sysError.write("JS", "Failed API Call", errorMessage);
    }
}

//#endregion



